import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { getMyRequests } from 'src/core/store/ducks/requests/actions'
import currencyMask from 'src/components/Formik/InputCurrency/mask'
import history from 'src/config/routes/history'
import ModalChangePassword from 'src/layouts/Dashboard/components/Side/components/modal-change-password'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from '../styles'
import Header from '../components/Header'
import RequestNumberFilter from '../../components/request-number-filter'
import StatusFilter from '../../components/StatusFilter'
import Table, { DataSource } from '../../components/Table'

export default function MyRequests() {
  useDocumentTitle('web.side.my-requests')
  const {
    me: { user },
    requests
  } = useSelector((state: ApplicationState) => ({
    me: state.me,
    requests: state.requests
  }))
  const dispatch = useDispatch()

  const [list, setList] = useState<DataSource[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [mustChangePassword, setMustChangePassword] = useState<boolean>(
    user?.must_change_password
  )

  function closeModalChangePassword() {
    setMustChangePassword(false)
  }

  useEffect(() => {
    dispatch(getMyRequests({ filterStatus: requests.filterStatus, page: 1 }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setList(
      requests.myRequests.map(
        ({
          cost,
          empowered_users,
          erp_code,
          request_id,
          request_number,
          request_user_data,
          requested_on,
          status,
          sync_status,
          title
        }) => ({
          cost: currencyMask({ formatStr: true, value: cost }).maskedValue,
          empowered_users,
          erp_code,
          id: request_id,
          key: request_id,
          number: request_number,
          startDate: moment.unix(requested_on).format('DD/MM/YYYY'),
          status,
          sync_status,
          title,
          users: request_user_data.map(
            ({ reason, status, traveler: { gender, name, user_id } }) => ({
              gender,
              name,
              reason,
              status,
              user_id
            })
          )
        })
      )
    )
  }, [requests.myRequests])

  return (
    <>
      <Header error={requests.myRequestsError} title="web.side.my-requests" />
      <CSS.HeaderFilters>
        <RequestNumberFilter
          initialValues={requests.filterRequestNumber}
          onChange={values => {
            dispatch(getMyRequests({ request_numbers: values, page: 1 }))
            setCurrentPage(1)
          }}
        />
        <StatusFilter
          defaultValue={requests.filterStatus}
          onChange={values => {
            dispatch(getMyRequests({ filterStatus: values, page: 1 }))
            setCurrentPage(1)
          }}
          options={[
            'approval_pending',
            'approval_reproved',
            'conference_pending',
            'closing_pending',
            'underway',
            'conference_reproved',
            'closing_reproved',
            'finished',
            'canceled'
          ]}
        />
      </CSS.HeaderFilters>
      <Table
        currentPage={currentPage}
        dataSource={list}
        loading={requests.myRequestsLoading}
        myRequests
        onChange={page => {
          dispatch(getMyRequests({ filterStatus: requests.filterStatus, page }))
          setCurrentPage(page)
        }}
        onRow={(record: DataSource) => ({
          onClick: () => history.push(`/my-requests/${record.id}/summary`)
        })}
        totalPages={requests.totalResults}
      />
      <ModalChangePassword
        toggle={closeModalChangePassword}
        visible={mustChangePassword}
      />
    </>
  )
}
